export default __webpack_public_path__ + "static/media/schema.926c3ef7.jpeg";